export const replaceTemplate = (template: string, variables: Record<string, string | number>): string => {
  return Object.keys(variables).reduce((accumulator, key) => {
    const regexp = new RegExp(`{{${key}}}`, 'g');
    return accumulator.replace(regexp, `${variables[key]}`);
  }, template);
};
